/**
 * WordPress dependencies
 */
import { useContext, useEffect, useRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import useShortcutEventMatch from './use-shortcut-event-match';
import { context } from '../context';
/**
 * Attach a keyboard shortcut handler.
 *
 * @param {string}   name               Shortcut name.
 * @param {Function} callback           Shortcut callback.
 * @param {Object}   options            Shortcut options.
 * @param {boolean}  options.isDisabled Whether to disable to shortut.
 */

export default function useShortcut(name, callback) {
  let {
    isDisabled
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const shortcuts = useContext(context);
  const isMatch = useShortcutEventMatch();
  const callbackRef = useRef();
  callbackRef.current = callback;
  useEffect(() => {
    if (isDisabled) {
      return;
    }

    function _callback(event) {
      if (isMatch(name, event)) {
        callbackRef.current(event);
      }
    }

    shortcuts.current.add(_callback);
    return () => {
      shortcuts.current.delete(_callback);
    };
  }, [name, isDisabled]);
}
//# sourceMappingURL=use-shortcut.js.map